import { render, staticRenderFns } from "./CamaraDashboard.vue?vue&type=template&id=de0af3c2&scoped=true&"
import script from "./CamaraDashboard.vue?vue&type=script&lang=ts&"
export * from "./CamaraDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraDashboard.vue?vue&type=style&index=0&id=de0af3c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0af3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('de0af3c2', component.options)
    } else {
      api.reload('de0af3c2', component.options)
    }
    module.hot.accept("./CamaraDashboard.vue?vue&type=template&id=de0af3c2&scoped=true&", function () {
      api.rerender('de0af3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Dashboard/CamaraDashboard.vue"
export default component.exports